import { Outlet } from 'react-router-dom';
import { Provider } from 'mobx-react';
import s from './index.module.scss';
import 'amfe-flexible'; //设置字体大小为屏幕的十分之一
import grtStore from '@/store/grtStore';
import withRouter from '@/components/withRouter';
import { useEffect } from 'react';
import { Storage } from '@/utils/Storage';
import VConsole from 'vconsole';
import { openConsole } from '@/utils/Mobile';
import { isInApp } from '@/utils/Mobile';
const MobileLayout = (props) => {
    const { navigate, location, searchParams } = props;
    let consoleParam = searchParams.get('console');
    const Authorization = searchParams.get('Authorization');
    const userAgent = searchParams.get('user-agent');

    useEffect(() => {
        if (consoleParam) {
            Storage.set('console', consoleParam);
        }
    }, [consoleParam]);
    useEffect(() => {
        let console = Storage.get('console');
        if (console) {
            window.vConsole = new VConsole();
        }
    }, []);

    useEffect(() => {
        if (isInApp()) {
            if (userAgent) {
                Storage.set('userAgent', userAgent);
            }
            if (Authorization) {
                Storage.set('Authorization', Authorization);
                const search = new URLSearchParams(window.location.search);
                search.delete('Authorization');
                navigate(
                    {
                        pathname: location.pathname,
                        search: search.toString()
                    },
                    { replace: true }
                );
            }
        }
    }, []);

    return (
        <Provider store={grtStore}>
            <div onClick={openConsole} className={[`grt-box grt-mobile-box ${s['mobile-wrap']}`]}>
                <Outlet></Outlet>
            </div>
        </Provider>
    );
};

export default withRouter(MobileLayout);
